export default "__VITE_ASSET__BjKc4K1K__"